(function () {
  function showToast(msg){
    let t = document.querySelector('.mj-toast');
    if(!t){
      t = document.createElement('div');
      t.className = 'mj-toast';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('mj-toast--show');
    setTimeout(() => t.classList.remove('mj-toast--show'), 2000);
  }

  async function addToCart(form){
    const btn = form.querySelector('button[type="submit"]');
    if(btn) btn.disabled = true;
    try{
      const fd = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: fd
      });
      if(!res.ok) throw new Error('Falha ao adicionar');
      const data = await res.json();

      // Atualiza contador do carrinho (Dawn e similares)
      const countEls = document.querySelectorAll(
        '#cart-icon-bubble .cart-count-bubble, .header__icon--cart .cart-count-bubble, [data-cart-count]'
      );
      const qty = data?.quantity ?? 1;
      countEls.forEach(el => {
        const current = parseInt(el.textContent || '0', 10);
        el.textContent = String(isNaN(current) ? qty : current + qty);
        el.classList.remove('hidden');
      });

      showToast('Adicionado ao carrinho!');
    } catch(e){
      showToast('Não foi possível adicionar. Tente novamente.');
      console.error(e);
    } finally{
      if(btn) btn.disabled = false;
    }
  }

  document.addEventListener('click', function(e){
    const btn = e.target.closest('.mj-atc-form .mj-atc-btn');
    if(!btn) return;
    const form = btn.closest('form.mj-atc-form');
    if(!form) return;
    e.preventDefault();
    addToCart(form);
  }, {passive:false});
})();
